import { LS2KidsMain } from "./tlc/ls2kids/ls2kids-main";


$(function() {
	LS2KidsMain.start();
});